import { createFileRoute } from '@tanstack/react-router';

import { AccountSetupForm } from '@/features/account-setup/components/account-setup-form';

export const Route = createFileRoute('/_account-setup/account-setup')({
  component: AccountSetupPage,
});

function AccountSetupPage() {
  return <AccountSetupForm />;
}
